import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";

function CapabilityPage() {
  return (
    <div className="min-h-screen bg-white text-black">
      <Navbar />
      <main>
        <section className="page-hero">
          <div className="container">
            <span className="eyebrow">Capability Statement | GovCon Ready</span>
            <h1>Capability statement content for the website</h1>
            <p>
              A web-ready version of ThoughtCodes' positioning, core
              capabilities, differentiators, and corporate information.
            </p>
          </div>
        </section>
        <section className="section">
          <div className="container split">
            <div>
              <div className="section-head">
                <div className="tag">Company Capability </div>
                <h2>
                  Secure, Scalable Solutions for Mission-Critical Programs
                </h2>
              </div>
              <p>
                ThoughtCodes delivers modern software, cloud, DevSecOps, and
                AI-enabled solutions that help agencies transition from legacy
                systems to secure, high-performing digital environments—faster
                and more efficiently.
              </p>
            </div>
            <div className="card">
              <h3>Key Differentiators</h3>
              <ul className="list-check">
                <li>Mission-focused, outcome-driven delivery</li>
                <li>
                  Integrated expertise across software, cloud, cybersecurity,
                  and AI
                </li>
                <li>Proven DevSecOps and Agile delivery capabilities</li>
                <li>
                  Security-first approach aligned with federal compliance
                  standards
                </li>
                <li>Small business agility with enterprise-level discipline</li>
                <li>
                  Experience supporting federal agencies (USAID, DOD, DHS)
                </li>
                <li>Rapid onboarding and scalable delivery teams</li>
              </ul>
            </div>
          </div>
        </section>
        <section className="section gradient-bg">
          <div className="container grid-3">
            <div className="page-card stat stat-interactive ">
              <h3>Core Capabilities</h3>
              <div className="text-md font-normal">
                Custom software and application development, Agile
                transformation, cloud and DevSecOps enablement, AI-driven
                automation, systems modernization, cybersecurity, and quality
                assurance testing.
              </div>
            </div>
            <div className="page-card stat stat-interactive ">
              <h3>Corporate Data</h3>
              <div className="text-md font-normal">
                CAGE: 8F4J8
                <br />
                UEI: TKAGKBGE2LQ3
                <br />
                NAICS: 541512, 541511, 541519, 518210, 541330, 541611
              </div>
            </div>
            <div className="page-card stat stat-interactive ">
              <h3>Contact</h3>
              <div className="text-md font-normal space-y-2">
                <div>Mahfuz Hussien</div>
                <a
                  href="mailto:info@thoughtcodes.com"
                  className="flex items-center gap-2"
                >
                  <svg
                    className="h-5 w-5 text-[#2196F3]"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={1.8}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M21.75 7.5v9a2.25 2.25 0 01-2.25 2.25h-15A2.25 2.25 0 012.25 16.5v-9m19.5 0A2.25 2.25 0 0019.5 5.25h-15A2.25 2.25 0 002.25 7.5m19.5 0v.243a2.25 2.25 0 01-.97 1.855l-7.5 5.25a2.25 2.25 0 01-2.56 0l-7.5-5.25a2.25 2.25 0 01-.97-1.855V7.5"
                    />
                  </svg>
                  <span>info@thoughtcodes.com</span>
                </a>
                <a href="tel:+7032312569" className="flex items-center gap-2">
                  <svg
                    className="h-5 w-5 text-[#2196F3]"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={1.8}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M2.25 4.5a1.5 1.5 0 011.5-1.5h2.25a1.5 1.5 0 011.5 1.29l.39 2.73a1.5 1.5 0 01-.43 1.3l-1.12 1.12a12 12 0 005.66 5.66l1.12-1.12a1.5 1.5 0 011.3-.43l2.73.39a1.5 1.5 0 011.29 1.5v2.25a1.5 1.5 0 01-1.5 1.5h-.75C9.31 21.75 2.25 14.69 2.25 6V4.5z"
                    />
                  </svg>
                  <span>+ (703) 231-2569</span>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default CapabilityPage;
